import { PdsWidget } from '../../pds-widget';
import { SelectField } from '../../models/grid-widget/select-field';
import { SelectFilter } from '../../models/grid-widget/select-filter';
import { SelectOption } from '../../interfaces/select-option';
import { map } from 'rxjs/operators';

export class PdsGwSelectFilter extends PdsWidget {
  is = 'pds-gw-select-filter';

  //Input
  filter: SelectFilter | null;

  blankObject = SelectFilter.blankObject;

  properties = {
    filter: {
      value: null
    }
  };

  attached(): void {
    super.attached();
    this.watch('filter.searchValue');
    let selectElement: HTMLElement | null = this.querySelector('select');
    if (selectElement != null && this.filter != null) {
      //If the searchValue is undefined, default it to the blank object.
      if (this.filter.searchValue == null) {
        this.filter.searchValue = SelectFilter.blankObject;
      }

      //This sets the default value of the select based on the filter object.
      (<any>selectElement).value = this.filter.searchValue;
    }
  }

  inputChange(): void {
    if (this.filter == null) {
      return;
    }

    let selectElement: HTMLSelectElement = <HTMLSelectElement>this.querySelector('select');
    if (selectElement.selectedIndex > 0) {
      this.filter.searchValue = selectElement.value;
    } else {
      this.filter.searchValue = SelectFilter.blankObject;
    }
    this.dispatchEvent(new Event('renderedElementValueChange', {bubbles: true}));
  }

  getSelectOptions(filter: SelectField): Array<{ value: string, text: string }> {
    if (this.filter == null) {
      return [];
    }

    //We aren't ever going to use the value of the blank object.
    return [{ value: '', text: ''}].concat(filter.selectOptions.array
      .map((option: {key: string, value: string}) => {
        return {value: option.value, text: option.key};
      }));
  }
}
